
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import{ Button, Badge} from 'react-bootstrap';
import React from 'react';
import { Link } from "react-router-dom";
import './LevelCrumbs.css'
import { FaTimesCircle } from 'react-icons/fa';
import { GoFileZip } from 'react-icons/go';
import DiscoveryTooltip from 'DiscoveryTooltip';
import {
  archiveInnerPath,
  archiveOuterName,
  isArchivePath,
} from 'Utils/archivePath';

const LevelCrumbs = (props) => {
  const path = props.path;
  const searchid = props.searchid;
  let entity, table, column = <span/>;


  if (props.table) {
    table = <LevelCrumb
      active={props.activeCrumb === 'table'}
      path={path + '/' + searchid +'/' + props.entity + '/' + props.table}
      // tableLabel: display name when the route param is schema-qualified
      // (schema.table) — the schema renders as its own badge, not in the crumb.
      name={props.tableLabel || props.table}
      archive={isArchivePath(props.table)}
     filterDataHandler={(value) => props.filterDataHandler(value)}
    />
  }
  return (
    <Breadcrumb className="shadow-sm widget-card" >
      <Breadcrumb.Item 
        active={props.activeCrumb === 'overview'} 
        linkAs={Link} linkProps={{ to: `/results/${searchid}`}}
      >
        {props.activeCrumb === 'overview' ? (
          <span>Discovery Overview</span>
        ) : (
          <DiscoveryTooltip text={'Return to Discovery Overview'} placement='top'>
            <span>Discovery Overview</span>
          </DiscoveryTooltip>
        )}
      </Breadcrumb.Item>
      {table}
    <StatusCrumb
      connection={props.connection}
      schema={props.schema}
      schemaLabel={props.schemaLabel}
      entity={props.entity}
      column={props.filteredByCol}
      resetFilter = {() => {  console.log('filtering 2'); props.resetFilter()}}
      />
    </Breadcrumb>
    )
}


const capitalize = (s) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : s);

const StatusBadge = (props) =>  (

    <Badge className="justify-content-end"  style={{   textTransform: 'capitalize'}}>
       {props.label}: {( props.name ? props.name.toLowerCase().replaceAll('_',' ') :  'All')}
    </Badge>) 


const StatusCrumb = (props) => {
  return (
    <Breadcrumb.Item
    active={true}
    className="ml-auto no-slash"
  >
     {/* Data source name — case preserved, unlike StatusBadge's lowercased filters. */}
     {props.connection && (
       <Badge className="justify-content-end mr-2">Source: {props.connection}</Badge>
     )}
     {/* Qualifier of the table's key — the schema/owner for relational sources, the
         database for MongoDB (Mongo has no schema level; the collection name is the
         breadcrumb itself). Omitted for unqualified rows (files). */}
     {props.schema && (
       <Badge className="justify-content-end mr-2" style={{ textTransform: 'none' }}>
         {capitalize(props.schemaLabel || 'schema')}: {props.schema}
       </Badge>
     )}
     <span style={{fontWeight:"bold"}}>Filter</span>
     <StatusBadge label="Field" name={props.column} />
     <StatusBadge label="Entity" name={props.entity} />
     {(
      ( (props.entity && props.entity !== 'ALL') || props.column) ? 
      <span className='model-link' onClick={() => {  console.log('filtering'); props.resetFilter()}}>
        <DiscoveryTooltip placement='top' text='Clear active filters'>
          <span>clear <FaTimesCircle  style={{marginLeft:'1px'}}  /> </span>
        </DiscoveryTooltip>
      </span>
       : 
       ''
       )}
     
   </Breadcrumb.Item>  
  )
}

const LevelCrumb = (props) => {
  const content = props.archive ? (
    <ArchivePathLabel value={props.name} />
  ) : (
    props.name
  );

  return (
    <Breadcrumb.Item
      active={props.active}
    >
      { props.link ? (
        <Link
        to={props.path}>
          {content}
        </Link>
      ) : (
        <span>
          {content}
        </span>
      )}
    </Breadcrumb.Item>
  )
}

/**
 * Render a virtual archive path as `<icon> outer.zip / inner/path` with a
 * tooltip carrying the full original value. Used by file-detail breadcrumbs
 * when the table name is actually a path inside a multi-entry archive.
 */
const ArchivePathLabel = ({ value }) => {
  const outer = archiveOuterName(value);
  const inner = archiveInnerPath(value);
  const tooltip = inner ? `${outer} -> ${inner}` : `${outer} (archive root)`;
  return (
    <DiscoveryTooltip text={tooltip} placement='top'>
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
        <GoFileZip aria-label='Inside archive' style={{ flexShrink: 0, opacity: 0.85 }} />
        <span style={{ fontWeight: 600 }}>{outer}</span>
        {inner ? (
          <>
            <span aria-hidden='true' style={{ opacity: 0.55 }}>/</span>
            <span style={{ opacity: 0.9 }}>{inner}</span>
          </>
        ) : (
          <span style={{ opacity: 0.55 }}>(archive root)</span>
        )}
      </span>
    </DiscoveryTooltip>
  );
};

export default LevelCrumbs
